import App from "@/App";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryProvider } from "@/providers/QueryProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import type { ModeType } from "@/types";

interface AppContainerProps {
	defaultMode?: ModeType;
	allowDemoMode?: boolean;
}

export default function AppContainer({ defaultMode, allowDemoMode }: AppContainerProps) {
	return (
		<ThemeProvider
			attribute="class"
			defaultTheme="light"
			enableSystem={false}
			disableTransitionOnChange
			storageKey="cash-forecaster-theme"
		>
			<QueryProvider>
				<TooltipProvider>
					<Toaster richColors duration={5000} closeButton />
					<App defaultMode={defaultMode} allowDemoMode={allowDemoMode} />
				</TooltipProvider>
			</QueryProvider>
		</ThemeProvider>
	);
}
